var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-container",attrs:{"data-index":"0"}},[_c('img',{attrs:{"src":_vm.src},on:{"click":function($event){return _vm.open($event)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }